import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './Testimonials.css';

const Testimonials = () => {
  const { t } = useTranslation();
  const placeholderAvatar = 'https://i.pravatar.cc/150?img=47';
  const testimonials = t('testimonial.list', { returnObjects: true }) || [
    {
      text: "Fazia anos que eu adiava o meu exame por medo e vergonha. Com a Lumina, finalmente consegui me cuidar no conforto da minha casa, sem julgamentos.",
      author: "Maria Silva",
      avatar: placeholderAvatar
    },
    {
      text: "Hoje, fiz o exame com tranquilidade pela manhã, antes de ir trabalhar. A praticidade da Lumina mudou completamente minha relação com o autocuidado.",
      author: "Ana Costa",
      avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=150&q=80"
    },
    {
      text: "A privacidade e o cuidado que a Lumina oferece me fizeram sentir segura e respeitada. Recomendo para todas as mulheres que buscam autonomia na saúde.",
      author: "Juliana Santos",
      avatar: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=150&q=80"
    }
  ];
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
  };
  const prevTestimonial = () => {
    setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section className="testimonials">
      <div className="container">
        <h2 className="testimonials-title">{t('testimonial.title')}</h2>
        <div className="testimonials-carousel">
          <button className="carousel-btn prev" onClick={prevTestimonial}>‹</button>
          <div className="testimonial-content">
            <p className="testimonial-text">
              "{testimonials[currentTestimonial].text}"
            </p>
            <div className="testimonial-author">
              <img
                src={testimonials[currentTestimonial].avatar}
                alt={testimonials[currentTestimonial].author}
                className="author-avatar"
                onError={(e) => {
                  e.currentTarget.onerror = null;
                  e.currentTarget.src = placeholderAvatar;
                }}
              />
              <span className="author-name">{testimonials[currentTestimonial].author}</span>
            </div>
          </div>
          <button className="carousel-btn next" onClick={nextTestimonial}>›</button>
        </div>
        <div className="carousel-dots">
          {testimonials.map((_, index) => (
            <button
              key={index}
              className={`dot ${index === currentTestimonial ? 'active' : ''}`}
              onClick={() => setCurrentTestimonial(index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;



